import { Link } from 'react-router-dom';
import { formatDate } from '@platform/core/lib/format';
import { cx } from '@platform/core/lib/cx';
import { routes } from '@platform/core/lib/routes';
import { recordNumber } from '@platform/engine/views/recordNumber';
import { useRecordTypeLabels } from '@platform/features/search/useRecordTypeLabels';
import { useAppSelector } from '@platform/state/hooks';
import { selectLang } from '@platform/state/selectors';
import type { IHomeViewRowProps } from './IHomeViewRowProps';
import { priorityText } from './priorityText';

/**
 * Рядок подання «Моя робота» (прототип v4 G:L1609): сітка 70px | назва | 140px | 90px | 90px — номер IBM Plex Mono 12px (голий, як у прототипі), назва 500 з «…»,
 * крапка й підпис статусу, пріоритет (варіант каталогу priorityKey мовою інтерфейсу — і для типів без поля пріоритету, як словник прототипу:
 * «Середній»), термін 600 праворуч (прострочений — колір попередження); рядок відкриває запис.
 */
export function HomeViewRow({ record, today }: IHomeViewRowProps) {
  const lang = useAppSelector(selectLang);
  const labels = useRecordTypeLabels(record.module, record.recordType);
  const keyed = useRecordTypeLabels(record.priorityKey?.module, record.priorityKey?.recordType);
  const status = labels.status(record.status);
  const due = (record.due ?? '').slice(0, 10);
  return (
    <Link className="hv-row" to={routes.record(record.module, record.recordType, record.id)}>
      <span className="hv-code" title={record.display}>{recordNumber(record)}</span>
      <span className="hv-title">{record.title || record.display}</span>
      <span className="hv-status"><span className="hv-dot" style={{ background: status.color }} aria-hidden="true" /><span className="hv-ellipsis">{status.label}</span></span>
      <span className="hv-muted">{priorityText(record, lang, keyed, labels)}</span>
      <span className={cx('hv-due', !!due && due < today && 'is-late')}>{formatDate(due, lang)}</span>
    </Link>
  );
}
